export const shouldShowMobileChatRouteLoader = ({
  isMobileView,
  isBroadcastMode,
  patientId,
  patient,
  isLoadingPatient,
  roomId,
  activeRoomId,
  isLoadingMessages,
  messageCount = 0
}) => {
  if (!isMobileView || isBroadcastMode || !patientId) {
    return false
  }

  if (isLoadingPatient || patient?.id !== patientId) {
    return true
  }

  if (patient?.auth_status === 'added') {
    return false
  }

  if (!roomId) {
    return true
  }

  return activeRoomId !== roomId || (isLoadingMessages && messageCount === 0)
}

/**
 * `data-state` of `#patient-room-chat`, for e2e tests.
 * - `loading`: a loader shows (load more included), or, outside broadcast, the chat has not caught up with the route:
 *   the route patient is not loaded yet, or this mount has not requested its room's messages yet. CHAT_ROOM_SELECTED and
 *   PATIENT_REQUESTED empty the thread first, so without this the chat would read `ready` over an empty thread.
 * - `records-only`: no chat thread (patient `auth_status` is `added`).
 * - `view-only`: `isActive === false`, ViewMode replaces the input.
 * - `ready`: anything else, including a failed messages request. It does not promise an input: there is none while
 *   `isActive` is unknown, or for users who cannot send messages.
 */
export const getChatDataState = ({
  showMobileChatRouteLoader,
  isBroadcastMode,
  patientId,
  patient,
  isLoadingPatient,
  roomId,
  requestedRoomId,
  isLoadingMessages,
  isRecordsOnly,
  isActive
}) => {
  const isRoutePatientPending = isLoadingPatient || (!!patientId && patient?.id !== patientId)
  const isRoomPending = !!roomId && requestedRoomId !== roomId
  const isSwitchingPatient = !isBroadcastMode && (isRoutePatientPending || isRoomPending)

  if (showMobileChatRouteLoader || isLoadingMessages || isSwitchingPatient) {
    return 'loading'
  }

  if (isRecordsOnly) {
    return 'records-only'
  }

  if (isActive === false) {
    return 'view-only'
  }

  return 'ready'
}
